/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import { useIntl } from 'react-intl'
import { Checkbox, TextField } from '@material-ui/core'
import { ButtonLoader } from '../../../../Loader/ButtonLoader'
import Autocomplete from '@material-ui/lab/Autocomplete'

const AllowedTaxField = ({ allowedTaxTypes, formAction, fieldName, labelKey, placeholderKey }) => {
  const intl = useIntl()
  const [taxes, setTaxes] = React.useState(formAction.values[fieldName].includes('all') ? allowedTaxTypes.filter((tax) => tax.key === 'all') : allowedTaxTypes.filter((tax) => formAction.values[fieldName].includes(tax.key)))

  React.useEffect(() => {
      if (!!allowedTaxTypes && !!allowedTaxTypes.length) {
        setTaxes(formAction.values[fieldName].includes('all') ? allowedTaxTypes.filter((tax) => tax.key === 'all') : allowedTaxTypes.filter((tax) => formAction.values[fieldName].includes(tax.key)))
      }
    },// eslint-disable-next-line react-hooks/exhaustive-deps
    [allowedTaxTypes])

  return (
    <Autocomplete
      multiple
      id={`Taxes.${fieldName}`}
      loading={!allowedTaxTypes?.length}
      loadingText={<ButtonLoader loading={true}/>}
      options={allowedTaxTypes || []}
      value={taxes}
      // freeSolo
      disableCloseOnSelect
      getOptionLabel={(option) => option.label}
      onChange={(event, value) => {
        let taxesList = (!!value && !!value.length) ? value.map(tax => tax.key) : []
        setTaxes(taxesList?.includes('all') ? allowedTaxTypes.filter(tax => tax.key === 'all') : value)
        formAction.setFieldTouched(fieldName, true, true)
        formAction.setFieldValue(fieldName, taxesList?.includes('all') ? ['all'] : taxesList)
      }}
      getOptionDisabled={(option) => formAction.values[fieldName]?.includes('all') && option.key !== 'all'}
      renderOption={(option, { selected }) => (
        <React.Fragment>
          <Checkbox
            color={'primary'}
            // disabled={formAction.values[fieldName]?.includes('all') && option.key !== 'all'}
            checked={formAction.values[fieldName]?.includes('all') || formAction.values[fieldName].includes(option.key)}
          />
          {option.label}
        </React.Fragment>
      )}
      renderInput={(params) => (
        <TextField {...params} variant="outlined"
                   label={intl.formatMessage({ id: labelKey })}
                   placeholder={intl.formatMessage({ id: placeholderKey })}
                   name={fieldName}
                   InputLabelProps={{
                     ...params?.InputLabelProps, shrink: true
                   }}
                   onChange={formAction.handleChange}
                   onBlur={formAction.handleBlur}
                   helperText={formAction.errors[fieldName] && formAction.touched[fieldName] && formAction.errors[fieldName]}
                   error={formAction.errors[fieldName] && formAction.touched[fieldName] !== undefined}
        />
      )}
    />
  )
}

export default AllowedTaxField
